import { encrypt, decrypt } from './crypto';

const getItem = (key: string) => {
  const plainText: string = localStorage.getItem(key) || '';
  return decrypt(plainText);
};

const setItem = (key: string, value: string) => {
  localStorage.setItem(
    key,
    value != null || value != undefined ? encrypt(value) : '',
  );
};

export default {
  getItem,
  setItem,
};
